import React from 'react';

import {
  Button,
  Paper
} from '@mui/material';
import {
  activityTemplates,
  routeDirectory
} from 'modules';

import { ChevronLeft } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import * as Table from '../Tier1ReturnAuthorizationsActivity/Table/Table';



export const AllTier1ReturnAuthorizationsActivity: React.FC = () => {
  const navigate = useNavigate();



  const handleClickBack = React.useCallback(
    () => {
      navigate(routeDirectory.admin.tier1ReturnAuthorizations.list.path('preAlertAcknowledged'), { replace: true });
    },
    [navigate]
  );



  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <Paper sx={{ padding: '10px' }}>
        <Button
          startIcon={<ChevronLeft />}
          onClick={handleClickBack}>
          Back
        </Button>

        <Table.FC
          filter={{}}
          columnIdsToRender={[
            'referenceNumber',
            'requestedDate',
            'client',
            'productName',
            'productSku',
            'serialNumber',
            'nsRmaRecord',
            'nsReceiptRecord',
            'shippingLabel'
          ]} />
      </Paper>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
